// extracted by mini-css-extract-plugin
export default {"wrapper":"CartV2_wrapper__e7L8y","button":"CartV2_button__70dUg","shoppingBag":"CartV2_shoppingBag__rDoEF","indicator":"CartV2_indicator__KH5dY"};